import {
    deleteFuelLoading,
    deleteFuelRequest,
    deleteFuelSuccess,
    deleteFuelReject,
    deleteFuelReset
} from "../../actions/fuel/delete";

export const deleteFuel = (id) => async (dispatch, getState) => {
    dispatch(deleteFuelLoading());
    try {
        const { data } = await deleteFuelRequest(getState, id);
        dispatch(deleteFuelSuccess(data))
    } catch (error) {
        dispatch(deleteFuelReject(error))
    } finally {
        setTimeout(() => { dispatch(deleteFuelReset()) }, 3000);
    }
    return Promise.resolve();
};